<template>
  <div class="dripship-container">
    <figure class="dropship-banner">
      <embed v-bind:src="dropShipSetting.ImageUrl" alt="" width="528" height="238" />
    </figure>
    <section :class="[
      'dropship-box',
      'error-block',
      errorMsg1 != '' ? 'is-error' : ''
    ]">
      <div class="dropship__title">
        Do you want to dropship this order?
        <tooltip
          popup-style="white-space: break-spaces;margin-top: -141px;z-index:999; margin-left: -9px; width: 310px; overflow-wrap: break-word; text-align: left; padding: 5px; ">
          <img src="https://img66.anypromo.com/frontimg/2020/icon/question-1.svg" alt="question" width="16"
            height="16" />
          <template #content>Instead of having the products shipped to you for the fulfillment, let AnyPromo do the
            heavy lifting! Just send us the addresses of your team/clients and we'll send the products straight to
            them.</template>
        </tooltip>
      </div>
      <div :class="[
        'multiple-locations',
        dropShip.needDropShip ? 'is-selected' : ''
      ]">
        <div class="dropship-title">
          <label>
            <input type="radio" name="location" id="multiple-locations" :checked="dropShip.needDropShip"
              v-on:click="setNeedDropShip(true)" /><span>Yes, I want to ship to multiple locations.</span>
          </label>
          <div class="dropship-innerbox" v-show="dropShip.needDropShip">
            <section style="padding: 5px" :class="[
              'form-control',
              'error-block',
              errorMsg3 != '' ? 'is-error' : ''
            ]">
              <h2>How many locations do you wish to dropship to?</h2>
              <div>
                <input type="text" v-model="dropShip.locationNum" class="location-num"
                  v-on:keyup="onChangeLocationNum($event)" v-on:input="onlyNumberLargeThanZero($event)" />
                <span class="error-label" style="margin-left: 0px; padding-left: 0px" v-html="errorMsg3"></span>
              </div>
              <span class="dropship-tips">*We will reach out to you after checking out to retrieve the
                shipping address details.</span>
            </section>
            <section style="margin-top: 5px; padding: 5px" :class="[
              'form-control',
              'error-block',
              errorMsg2 != '' ? 'form-error' : ''
            ]">
              <h2>Do you wish to add more items to the dropship?</h2>
              <div>
                <div>
                  <label>
                    <input type="radio" name="more-items" id="yesMore" :checked="dropShip.needAddMore"
                      v-on:click="setNeedAddMore(true)" /><span>Yes, please have someone reach out to me.</span>
                  </label>
                </div>
                <div>
                  <label>
                    <input type="radio" name="more-items" id="noMore" :checked="dropShip.needAddMore === false"
                      v-on:click="setNeedAddMore(false)" /><span>No, this is the only item I wish to send.</span>
                  </label>
                </div>
              </div>
              <div class="error-label" v-html="errorMsg2"></div>
            </section>
          </div>
        </div>
        <div>
          <label>
            <input type="radio" name="location" id="single-location" :checked="dropShip.needDropShip === false"
              v-on:click="setNeedDropShip(false)" /><span>No, I want to ship to a single location.</span>
          </label>
        </div>
      </div>
      <div class="error-label" v-html="errorMsg1"></div>
    </section>
    <div class="addon-btns">
      <ap-button type="primary" size="small" @click="onClick" v-show="!submitSatus"
        :disabled="errorMsg1 !== '' || errorMsg2 !== '' || errorMsg3 !== ''">Continue</ap-button>
      <img src="https://img66.anypromo.com/frontimg/2023/Icon/loader.gif" alt="" class="submit-loading"
        v-show="submitSatus" />
    </div>
  </div>
</template>

<script lang="ts">
import { ApButton } from '@anypromo/components-pc'
import { computed, defineComponent, onMounted, ref } from 'vue'
import { getTotalQty, useWindow } from '../composables'
import { useDropShip } from '../store/modules/dropShip'
import { useProductSpec } from '../store/modules/productSpec'
import Tooltip from './tooltip.vue'
import { isNumeric } from '@/components/utils'

export default defineComponent({
  props: {
    submitSatus: {
      type: Boolean,
      default: false
    }
  },
  emits: ['go-next'],
  components: { ApButton, Tooltip },
  setup (props, { emit }) {
    const { dropShipSetting } = useWindow()
    const productSpecState = useProductSpec()
    const dropShipState = useDropShip()

    // const dropShipChecked = ref(false);
    // const addMoreChecked = ref(false);
    const errorMsg1 = ref('')
    const errorMsg2 = ref('')
    const errorMsg3 = ref('')

    const dropShip = computed(() => dropShipState.getDropShip)

    const setNeedDropShip = (val: boolean) => {
      clearErrorMsg()
      dropShipState.setNeedDropShip(val)
    }

    const setNeedAddMore = (val: boolean) => {
      clearErrorMsg()
      dropShipState.setNeedAddMore(val)
    }

    const onChangeLocationNum = (evt: Event) => {
      CheckQty()
    }

    const onlyNumberLargeThanZero = (evt: Event) => {
      CheckQty()
    }

    const clearErrorMsg = () => {
      errorMsg1.value = ''
      errorMsg2.value = ''
      errorMsg3.value = ''
    }
    const Check = () => {
      clearErrorMsg()
      if (dropShip.value.needDropShip === undefined) {
        errorMsg1.value = 'Please confirm whether to dropship this order.'
      } else if (dropShip.value.needDropShip) {
        if (dropShip.value.needAddMore === undefined) {
          errorMsg2.value =
            'Please confirm whether to add more items to the dropship.'
        }
        CheckQty()

      }
      return (
        errorMsg1.value === '' &&
        errorMsg2.value === '' &&
        errorMsg3.value === ''
      )
    }

    const totalQty = computed(() =>
      getTotalQty(productSpecState.getSelectedList)
    )

    const CheckQty = () => {
      errorMsg3.value = ''
      // 先检查是否为数字
      if (isNumeric(dropShipState.getLocationNum) == false) {
        errorMsg3.value = 'Please input locations.'
        return;

      }

      if (dropShipState.getLocationNum < 1) {
        errorMsg3.value = 'Please input locations.'
      } else {
        var minLocations = Math.ceil(totalQty.value / 5)
        if (minLocations > dropShipState.getLocationNum) {
          errorMsg3.value =
            'A minimum of ' + minLocations + ' locations is required.'
        } else if (dropShipState.getLocationNum > totalQty.value) {
          errorMsg3.value =
            "The number of locations can't exceed the total qty(" +
            totalQty.value +
            ')'
        }
      }
    }
    const onClick = () => {
      if (!Check()) {
        return
      }
      // const model: DropShipModel = {
      //   addlProductionTime: dropShipSetting.AddlProductionTime,
      //   addMoreChecked: needAddMore.value !== 0,
      //   dropShipChecked: needDropShip.value !== 0,
      //   needDropShip: needDropShip.value === 1,
      //   locationNum: locationNum.value,
      //   needAddMore: needAddMore.value === 1
      // }
      // dropShipState.setDropship(model)
      emit('go-next')
    }

    return {
      dropShipSetting,
      dropShip,
      errorMsg1,
      errorMsg2,
      errorMsg3,
      setNeedDropShip,
      setNeedAddMore,
      onChangeLocationNum,
      onlyNumberLargeThanZero,
      onClick
    }
  }
})
</script>
<style lang="less">
.dripship-container {
  padding: 10px;
}

.dropship-banner {
  margin: 0;
  width: 528px;
  height: 238px;
}

.multiple-locations,
.single-location {
  position: relative;
}

.dropship {
  &__title {
    font-size: 15px;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
  }
}

.dropship-box {
  padding: 5px;
  margin-top: 20px;
  border: 1px solid transparent;

  h2 {
    font-size: 15px;
    font-weight: 600;
    margin: 0;
  }

  label {
    display: flex;
    font-weight: 500;
    cursor: pointer;
    font-size: 14px;
    padding: 5px 10px;
    margin: 0;
    align-items: center;

    &>input {
      display: none;
    }

    &>span {
      vertical-align: middle;
      display: inline-flex;
      margin: 0;
      align-items: center;

      &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 12px;
        height: 12px;
        border-radius: 3px;
        border: 1px solid #a7a9ac;
        margin-right: 5px;
        margin-bottom: 1px;
      }

      &:hover {
        color: #cd4d08;
      }
    }
  }

  .dropship-innerbox {
    background: #eaf0f5;
    display: none;
    margin-bottom: 10px;
    font-size: 14px;
    padding: 15px 25px;
  }

  .location-num {
    border: 1px solid transparent;
    border-radius: 5px;
    padding: 5px;
    margin: 10px 3px 3px 0;
    box-shadow: 0 0 5px #ccc;
    width: 100px;
  }

  .is-selected {
    .dropship-title {
      background: #b7d2e6;
    }

    .dropship-innerbox {
      display: block;
    }
  }
}

.dropship-box input[type='radio']:checked+span:before {
  background: url(https://img66.anypromo.com/frontimg/2021/Icon/ico-check-05.svg) no-repeat 0 0;
  background-size: 11px 10px;
}
</style>
